<template>
  <div class="h-full w-full px-2">
    <template v-if="genre.id">
      <genre-place-list
        @openPlace="onOpenPlace"
        :genre="genre"
      />
    </template>
    <template v-else>
      <template v-if="searchWord.length > 0">
      <search-result
        :searchWord="searchWord"
        @openPlace="onOpenPlace"
        :searchType="searchType"
      />
    </template>
    <template v-else>
      <div class="bg-gray-light border border-pale_greem border-b-0 rounded h-full">
        <div @click="onMyLocation" class="px-4 py-3 border border-link rounded">
          <p class="flex items-center text-body-light">
            <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" class="mr-2 fill-current"><path d="m12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94v-2.06h-2v2.06c-4.17.46-7.48 3.77-7.94 7.94h-2.06v2h2.06c.46 4.17 3.77 7.48 7.94 7.94v2.06h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94h2.06v-2zm-8.94 8c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"/></svg>
            <span class="flex-grow">現在地</span>
          </p>
        </div>
      </div>
      <history @openPlace="onOpenPlace" class="mt-4" />
    </template>
    </template>
  </div>
</template>

<script>
import History from './History'
import SearchResult from './SearchResult'
import GenrePlaceList from './GenrePlaceList'

export default {
  components: {
    History,
    SearchResult,
    GenrePlaceList
  },
  props: {
    genre: {
      type: Object,
      required: true
    },
    searchWord: {
      type: String,
      required: true
    },
    searchType:{
      type: String,
      required: false
    }
  },
  methods: {
    onSelectGenre: function (genre) {
      this.$emit('selectGenre', genre)
    },
    onOpenPlace: function (place) {
      this.$store.dispatch('map/setOffset', true)
      this.$store.dispatch('drawer/close')
      this.$store.dispatch('map/updateSpotMarkerList', [])
      if (place.isGooglePlace || place.isEkispertPlace) {
        this.$store.dispatch('map/updateGooglePlaceMarker', place)
      }
      if(this.searchType !== undefined){
        if (this.searchType === "departure"){
          this.$store.dispatch('map/setSearchFrom', place)
        } else {
          this.$store.dispatch('map/setSearchTo', place)
        }
        this.$store.dispatch('drawer/openPlaceInput', { place: place, full: true })
        this.$store.dispatch('drawer/hideButton')
      } else {
        this.$store.dispatch('drawer/openPlace', { place: place, full: true })
        this.$store.dispatch('drawer/showButton')
      }
    },
    onMyLocation: function () {
      this.$emit('clearForm')
      this.$emit('closeSearchPanel')
    }
  }
}
</script>
